<template>
	<div class="main-wrapper main-wrapper--stars" v-if="descriptionAM && descriptionAM.full">
		<div class="about-wrapper">
			<h2 class="orange uppercase">Твоя асиметрична модель</h2>
			<div class="about-text" v-if="!isMobile && descriptionAM.full" v-html="descriptionAM.full">
      </div>
      <div class="about-text" v-if="isMobile && descriptionAM.short" v-html="descriptionAM.short">
      </div>
      <router-link  class="card-hover button orange-btn" :to="{ name: 'asymmetric-model' }">
        Старт
      </router-link>
		</div>
	</div>

</template>

<script>
	import { mapGetters } from 'vuex';
	import { mixins } from '@/mixins';
  import {EventBus} from "@/components/bus";

	export default {
		mixins: [mixins],
		components: {
		},
		computed: {
			...mapGetters({
				user: 'user',
				loggedIn: 'loggedIn',
        descriptionAM: 'descriptionAM',

			}),
		},
		beforeMount() {
            this.$store.dispatch('logged', true);
            this.$store.dispatch('getUserData')
                .then(() => {
                  this.$store.dispatch('getAmQuestions')
                })

            .catch(e => {
                this.$router.push({ name: 'welcome' })
            })
		},
  }
</script>